<pgh-modal-window size="md" *ngIf="modalData">
  <div modal-title>
    <h4><adp-label [labelKey]="modalData.headerKey"></adp-label></h4>
    <hr>
  </div>
  <div modal-body>
    <div *ngIf="!!modalData.title; else titleKey" class="text-center mb-20">
      {{modalData.title}}
    </div>
    <div>
      <p *ngIf="!!modalData.content; else contentKey" class="mb-20 w-wrap">
        {{modalData.content}}
      </p>
    </div>
    <div *ngIf="!modalData.isProd && !!modalData.errorCode">
      <b class="pr-10"><adp-label labelKey="Global_Modal_Error_Code_Label"></adp-label></b>
      {{modalData.errorCode}}
    </div>
    <div *ngIf="!modalData.isProd && !!modalData.errorMessage">
      <b class="pr-10"><adp-label labelKey="Global_Modal_Error_Message_Label"></adp-label></b>
      {{modalData.errorMessage}}
    </div>
    <div *ngIf="!modalData.isProd && !!modalData.source">
      <b class="pr-10"><adp-label labelKey="Global_Modal_Error_Source_Label"></adp-label></b>
      {{modalData.source}}
    </div>
    <div *ngIf="!!modalData.errorId">
      <b class="pr-10"><adp-label labelKey="Global_Modal_Error_Id_Label"></adp-label></b>
      {{modalData.errorId}}
    </div>
  </div>
  <div modal-footer>
    <button mat-flat-button color="accent" type="button" (click)="closeModal()">
      <adp-label [labelKey]="modalData.buttonTextKey"></adp-label>
    </button>
  </div>
</pgh-modal-window>
<ng-template #contentKey>
  <p *ngIf="modalData.contentKey?.length" class="mb-20 w-wrap">
    <adp-label [labelKey]="modalData.contentKey"></adp-label>
  </p>
</ng-template>
<ng-template #titleKey>
  <p *ngIf="modalData.titleKey?.length" class="mb-20 w-wrap">
    <adp-label [labelKey]="modalData.titleKey"></adp-label>
  </p>
</ng-template>
